import { render, staticRenderFns } from "./SoundWaveAnim.vue?vue&type=template&id=7900a808&scoped=true"
import script from "./SoundWaveAnim.vue?vue&type=script&lang=js"
export * from "./SoundWaveAnim.vue?vue&type=script&lang=js"
import style0 from "./SoundWaveAnim.vue?vue&type=style&index=0&id=7900a808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7900a808",
  null
  
)

export default component.exports